<template>
    <div class="head">
        <div class="headnav" v-if="navFixed">
            <div class="navbox">
                <div class="menubar">
                    <Icon @click.native="openbar" type="drag" size="40"></Icon>
                </div>
                <div class="logo">
                    <router-link to="/"><img src="../../assets/img/logo.svg" alt=""></router-link>
                </div>
                <div class="search pcshow">
                    <router-link to="/download">
                        <button id="searchBtn">下载</button>
                        <Icon type="arrow-down-a"></Icon>
                    </router-link>
                </div>
            </div>
        </div>
        <transition :duration="{enter:1000,leave:1000}"
            enter-active-class="animated bounceInLeft fade-enter-active"
            leave-active-class="animated bounceOutLeft fade-leave-active">
            <div v-if="menushow" class="menu">
                <Icon @click.native="closebar" type="close-round"></Icon>
                <ul>
                    <li><router-link to="/">首页</router-link></li>
                    <li><router-link to="/zongshu">研究综述</router-link></li>
                    <li><router-link to="/brand">品牌榜</router-link></li>
                    <li><router-link to="/country">国别分类排名</router-link></li>
                    <li><router-link to="/sector">细分领域排名</router-link></li>
                    <li><router-link to="/download">报告下载</router-link></li>
                    <li><router-link to="/sources">榜单方法论</router-link></li>
                    <li><router-link to="/copyright">版权声明</router-link></li>
                    <li><router-link to="/organization">发布机构</router-link></li>
                    <li><router-link to="/contact">联系我们</router-link></li>
                    <li><router-link to="/english">ENGLISH</router-link></li>
                </ul>
            </div>   
        </transition>
    </div>
</template>

<script>
export default {
    name: 'headnav',
    data () {
        return {
            menushow: false,
            navFixed: true,
        }
    },
    methods: {
        openbar:function() {
            this.menushow = true
        },
        closebar:function() {
            this.menushow = false
        },
        // handleScroll () {
        //     var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        //     // console.log(scrollTop)
        //     var i = 10
        //     var scroll = scrollTop - this.i
        //     this.i = scrollTop
        //     if(scroll > 0) {
        //         this.navFixed = false
        //     } else {
        //         this.navFixed = true
        //     }
        // }
    },
    // mounted () {
    //     window.addEventListener('scroll', this.handleScroll,true);
    // },
}
</script>

<style scoped>
    .fade-enter, .fade-leave{
          opacity: 0;
     }
    .fade-enter-active, .fade-leave-active{
        transition:opacity 1s;
    }
    .head {
        position: relative;
        width: 100%;
    }
    .headnav {
        width: 100%;
        height: 70px;
        background: #ffffff;
        box-shadow: 0 0 14px 0 #505050;
        position: fixed;
        top: 0;
        z-index: 9;
    }
    .navbox {
        max-width: 1440px;
        height: 70px;
        margin: 0 auto;
        padding: 0 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .menu {
        position: fixed;
        top: 0;
        left: 0;
        height: 1000px;
        background: #fff;
        box-shadow: 0 0 14px 0 #333333;
        padding: 60px 40px 40px 40px;
        width: 330px;
        z-index: 99;
        transition: all 5s;
    }
    .menu i {
        position: absolute;
        top: 20px;
        left: 40px;
        font-size: 30px;
        cursor: pointer;
        font-weight: normal;
        color: #505050;
    }
    .menu ul li {
        text-align: left;
        padding: 10px 0;
    }
    .menu ul li a{
        color: #505050;
        font-size: 18px;
    }
    .menu ul li a:hover {
        color: #1e6da6;
    }
    .menubar {
        cursor: pointer;
    }
    .menubar, .logo, .search {
        display: flex;
        align-items: center;
    }
    .menubar i {
        cursor: pointer;
        color: #505050;
    }
    .head .logo img{
       width: 180px;
   }
   .search {
       position: relative;
   }
   .search button {
        outline: none;
        padding: 8px 30px 8px 15px;
        border: solid 2px #505050;
        font-weight: bold;
        background: transparent;
        cursor: pointer;
        transition: all 0.5s;
        color: #505050;
   }
    #searchBtn:hover {
       border: solid 2px #1e6da6;
       color: #1e6da6;
    }
    .search .ivu-icon {
        position: absolute;
        top: 8px;
        right: 10px;
        font-size: 24px;
        color: #505050;
        transition: all 0.5s;
    }
    .search:hover .ivu-icon {
        color: #1e6da6;
    }
    @media screen and (max-width:1366px) {
        .menu {
            position: fixed;
            top: 0;
            left: 0;
            width: 260px;
        }
        .menu ul li {
            padding: 5px 0;
        }
        .menu ul li a {
            color: #505050;
            font-size: 16px;
        }
    }
    @media screen and (max-width: 768px) {
        .pcshow {
            display: none;
        }
        .headnav {
            justify-content: space-between;
            padding: 0 10px;
            height: 60px;
        }
        .navbox {
            padding: 0;
            height: 60px;
        }
         .menu ul li {
            padding: 5px 0;
        }
        .menu ul li a {
            color: #505050;
            font-size: 14px;
        }
        .head .logo img {
            width: 120px;
        }
        .center2 .ivu-col-span-12 {
            display: block;
            width: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/public/headnav.vue